import { IAdapter } from './interface'

export const createPartytownAdapter = (): IAdapter => {
	return {
		registerPort: ({ remotePort }) => {
			// @ts-ignore
			window.externalComponentRendererAPI.registerRemoteUiPort({ port: remotePort })
		},
	}
}
